module.exports = __webpack_public_path__ + "fonts/GT-America-Bold.083876af.woff";